export default "__VITE_ASSET__eIzoQ5BE__"